import React, { useEffect, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Button, notification, Alert } from 'antd';
import { useParams } from "react-router-dom";
import { useCompetition } from "../../../../base-react/hooks/Competition";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
var JudgeSource = models.judges.JudgeSource;
var EventSource = models.competitions.EventSource;
import { Localization, _T } from "../../../../base-react/src/Localization";
import { FileAddOutlined } from "@ant-design/icons";
import { SortableList, SortableListItem } from '../../../components/SortableList';
import { EventCompetitionEdit } from './components/EventCompetitionEdit';
import { Loading } from '../../../../base-react/components/Loading';
import { formatCompetitionDates } from '../overview';
const { Title } = Typography;
export const EventCompetitions = () => {
    let { event_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(event_id);
    const [editedItem, setEditedItem] = useState();
    const [isValid, setIsValid] = useState(true);
    const [classes, loadingClasses] = Stream(ClassesSource(event_id));
    const [judges, loadingJudges] = Stream(JudgeSource(event_id));
    useEffect(() => {
        if (classes && judges) {
            const eventJudges = judges.filter((judge) => judge.competition_id === (event === null || event === void 0 ? void 0 : event.competition_id));
            const teamCount = classes.reduce((sum, item) => sum + parseInt(item.class_count, 10) || 0, 0);
            setIsValid(classes.length + eventJudges.length + teamCount === 0);
        }
    }, [classes, judges]);
    if (loadingCompetition || loadingClasses || loadingJudges) {
        return React.createElement(Loading, null);
    }
    const onAddCompetition = () => {
        setEditedItem({ competition_federation: event === null || event === void 0 ? void 0 : event.competition_federation });
    };
    const onSorted = (list) => {
        list.forEach(async (item, index) => {
            const updateItem = {
                ...item,
                competition_order: index + 1
            };
            try {
                await Api.update(`${EventSource(event_id).url}/${updateItem.competition_id}`, updateItem);
            }
            catch (err) {
                notification.error({
                    message: err.message
                });
            }
        });
    };
    const footer = () => (React.createElement(Button, { icon: React.createElement(FileAddOutlined, null), onClick: onAddCompetition, disabled: !canEdit }, _T('common.add', { name: _T('competition.children.title').toLowerCase() })));
    const renderItem = (item) => (React.createElement(SortableListItem, { item: item, idAttribute: 'competition_id', actions: [
            React.createElement(Button, { disabled: !canEdit, onClick: () => setEditedItem(item) }, _T('common.edit'))
        ], title: item.competition_name, description: item.competition_federation, disabled: !canEdit }));
    const eventDateLabel = event ? formatCompetitionDates(event.competition_date, event.competition_end_date) : '';
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, { key: inputCompetition && inputCompetition.competition_id }, event && event.competition_name),
                eventDateLabel && React.createElement("p", null, eventDateLabel),
                React.createElement("p", null,
                    event && event.competition_location,
                    " - ",
                    (event === null || event === void 0 ? void 0 : event.competition_country) && Localization.getCountryName(event.competition_country)))),
        React.createElement(BodyContainer, null,
            React.createElement(Alert, { type: "info", showIcon: true, style: { marginBottom: 16 }, title: _T('competition.children.guide.title'), description: _T('competition.children.guide.description') }),
            (isValid && competitions && event) ?
                React.createElement(SortableList, { contextId: event.competition_id, loading: loadingCompetition, items: competitions, idAttribute: 'competition_id', renderItem: renderItem, footer: footer(), onSorted: onSorted, disabled: !canEdit })
                :
                    React.createElement(Alert, { title: _T('competition.error.createChildCompetitions'), type: "info" })),
        React.createElement(EventCompetitionEdit, { event_id: event_id, item: editedItem, visible: editedItem != undefined, onClose: () => setEditedItem(undefined), disabled: !canEdit })));
};
